
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"#CCE8FF","d":"M15 32h3v4h-3z"}}),_c('circle',{attrs:{"cx":"16.5","cy":"28.5","r":"2.5","fill":"#CCE8FF"}}),_c('path',{attrs:{"fill":"#2196F3","d":"M20 31.329V33h11V14h-6a1 1 0 01-1-1V6H9v27h4v-1.671a4.5 4.5 0 117 0zm-2 1.415c-.47.166-.974.256-1.5.256s-1.03-.09-1.5-.256v2.779l1.129-.451a1 1 0 01.742 0l1.129.451v-2.78zM13 35H8.5A1.5 1.5 0 017 33.5v-28A1.5 1.5 0 018.5 4h17.96L33 11.63V33.5a1.5 1.5 0 01-1.5 1.5H20v2a1 1 0 01-1.371.928l-2.129-.851-2.129.851A1 1 0 0113 37v-2zm17.615-23L26 6v6h4.615zM23 26h4v2h-4v-2zM13 16h14v2H13v-2zm0 4h14v2H13v-2zm3.5 11a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"}})])])
          )
        }
      }
    